import { render, staticRenderFns } from "./Limit.vue?vue&type=template&id=4a871c78&scoped=true&"
import script from "./Limit.vue?vue&type=script&lang=js&"
export * from "./Limit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a871c78",
  null
  
)

export default component.exports